// import React, { useState } from 'react';
// import './TagInput.css'; // We'll create this CSS file next

// const TagInput = () => {
//   const [tags, setTags] = useState([]);
//   const [inputValue, setInputValue] = useState('');

//   const handleInputChange = (e) => {
//     setInputValue(e.target.value);
//   };

//   const handleInputKeyDown = (e) => {
//     if (e.key === 'Enter' && inputValue.trim() !== '') {
//       e.preventDefault();
//       // Add new tag if it doesn't already exist
//       if (!tags.includes(inputValue.trim())) {
//         setTags([...tags, inputValue.trim()]);
//       }
//       setInputValue('');
//     }
//   };

//   const removeTag = (indexToRemove) => {
//     setTags(tags.filter((_, index) => index !== indexToRemove));
//   };

//   return (
//     <div className="tag-input-container">
//       <div className="tags-container">
//         {tags.map((tag, index) => (
//           <span key={index} className="tag">
//             {tag}
//             <button
//               type="button"
//               className="tag-remove"
//               onClick={() => removeTag(index)}
//             >
//               ×
//             </button>
//           </span>
//         ))}
//         <input
//           type="text"
//           value={inputValue}
//           onChange={handleInputChange}
//           onKeyDown={handleInputKeyDown}
//           placeholder="Type keyword and press Enter..."
//           className="tag-input-field"
//         />
//       </div>
//     </div>
//   );
// };

// export default TagInput;


import React, { useState, useEffect } from "react";
import "./TagInput.css";

const TagInput = ({ value = [], onChange }) => {
  const [tags, setTags] = useState(value);
  const [inputValue, setInputValue] = useState("");

  // Keep local state in sync when parent updates `value`
  useEffect(() => {
    setTags(value);
  }, [value]);

  const updateTags = (updated) => {
    setTags(updated);
    if (onChange) onChange(updated);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const addTag = (val) => {
    const newTag = val.trim();
    if (newTag !== "" && !tags.some((t) => t.toLowerCase() === newTag.toLowerCase())) {
      updateTags([...tags, newTag]);
    }
  };

  const handleInputKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === ",") && inputValue.trim() !== "") {
      e.preventDefault();
      addTag(inputValue);
      setInputValue("");
    } else if (e.key === "Backspace" && inputValue === "" && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };

  const removeTag = (indexToRemove) => {
    const updated = tags.filter((_, index) => index !== indexToRemove);
    updateTags(updated);
  };

  return (
    <div className="tag-input-container">
      <div className="tags-container">
        {tags.map((tag, index) => (
          <span key={index} className="tag">
            {tag}
            <button
              type="button"
              className="tag-remove"
              onClick={() => removeTag(index)}
            >
              ×
            </button>
          </span>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyDown}
          placeholder="Type keyword and press Enter..."
          className="tag-input-field"
        />
      </div>
    </div>
  );
};

export default TagInput;
